import { axios, i18n, apiURL } from '../main'

export default {
    state: { // state des Moduls wird direkt auf die variable state.modulX gemappt
        news: [],
        ungelesen: 0
    },
    actions: {
        loadNews: async function ({ commit }, domID) {
            var news = await axios.get(apiURL + 'public.cfc?method=getNews', { params: { domID: domID, locale: i18n.locale } })
            await commit('setNews', news.data)
        },
    },
    mutations: {
        setNews: function (state, news) {
            state.news = news
        },
    }
}